// components/modals/ContactFormAutoModal.tsx
'use client';

import * as React from 'react';
import { useRef } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { cn } from '@/lib/utils';
// import { Sparkles, Mail, PhoneCall, ArrowRight } from 'lucide-react';
// import Link from 'next/link';
import OfferCountdown from '../offer-countdown';

export default function ContactFormAutoModal({
    openDelayMs = 15000,
    oncePerSession = true,
    children,
    className,
}) {
    const [open, setOpen] = React.useState(false);
    const scrollRef = useRef(null);

    React.useEffect(() => {
        const key = 'contact_modal_shown';

        // if (oncePerSession && typeof window !== 'undefined') {
        //     const already = sessionStorage.getItem(key);
        //     if (already === '1') return;
        // }

        // const t = window.setTimeout(() => {
        //     setOpen(true);
        //     if (oncePerSession) sessionStorage.setItem(key, '1');
        // }, openDelayMs);

        // return () => window.clearTimeout(t);
    }, [openDelayMs, oncePerSession]);

    const onWheel = (e) => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop += e.deltaY;
            e.preventDefault(); // prevent default if necessary
        }
    };

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent
                className={cn(
                    'overflow-hidden border-0 p-0 shadow-2xl lg:min-w-[1000px]!',
                    'bg-white/80 backdrop-blur-xl',
                    className
                )}
            >
                {/* Creative glow */}
                {/* <div className="pointer-events-none absolute -left-28 -top-28 h-72 w-72 rounded-full bg-orange-500/20 blur-3xl" />
                <div className="pointer-events-none absolute -right-32 -bottom-32 h-80 w-80 rounded-full bg-sky-500/20 blur-3xl" /> */}

                <div className="flex gap-0">
                    {/* LEFT: Creative panel */}
                    <div className="relative hidden w-full max-w-[450px] bg-primary lg:flex justify-center items-center">
                        <div
                            className="absolute left-0 right-0 top-0 w-full h-full opacity-30"
                            style={{
                                backgroundImage:
                                    "url('/international-day-education-with-books.png')",
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                            }}
                        ></div>
                        <section className="w-full text-center container">
                            <h1 className="fs-36 text-white text-center font-serif font-bold leading-tight uppercase mb-8 tracking-widest">
                                <span className="fs-66 font-bold"> LAUNCH</span> <br /> YOUR BOOK
                            </h1>

                            <div className="mb-8 flex justify-center items-center">
                                <OfferCountdown />
                            </div>

                            <div className="bg-secondary -mx-6 text-[3rem] font-serif font-extrabold py-1 mb-8 tracking-wide text-white">
                                50% <span className="font-normal ml-2">DISCOUNT</span>
                            </div>
                        </section>
                    </div>

                    {/* RIGHT: Your existing contact form */}
                    <div className="relative p-0 w-full overflow-hidden">
                        <div
                            className="rounded-2xl max-sm:h-[500px] max-lg:h-auto bg-white p-0 max-[1399px]:h-[550px] max-[1399px]:overflow-y-auto max-[1399px]:overflow-x-hidden"
                            ref={scrollRef}
                            onWheel={onWheel}
                            tabIndex={0}
                            style={{ WebkitOverflowScrolling: 'touch' }}
                        >
                            {/* drop your existing form here */}
                            {children}
                        </div>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}
